import { useEffect, useState } from 'react'
import { useTheme } from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'

interface ScrollIndicatorProps {
  show: boolean
}

const ScrollIndicator = ({ show }: ScrollIndicatorProps) => {
  const [visible, setVisible] = useState(show)
  const theme = useTheme()
  
  useEffect(() => {
    // Reset visibility when show prop changes (like on page refresh)
    setVisible(show)
    
    if (show) {
      const handleInteraction = () => {
        setVisible(false)
      }
      
      // Hide on any user interaction
      window.addEventListener('touchstart', handleInteraction, { once: true })
      window.addEventListener('click', handleInteraction, { once: true })
      window.addEventListener('scroll', handleInteraction, { once: true })
      
      return () => {
        window.removeEventListener('touchstart', handleInteraction)
        window.removeEventListener('click', handleInteraction)
        window.removeEventListener('scroll', handleInteraction)
      }
    }
  }, [show])

  if (!visible) return null

  return (
    <div 
      style={{
        position: 'absolute',
        top: '50%',
        right: '10px',
        transform: 'translateY(-50%)',
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.7)' : 'rgba(255,255,255,0.9)',
        borderRadius: 20,
        padding: '4px 8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        animation: 'pulse 2s infinite',
        zIndex: 10
      }}
    >
      <span style={{ 
        fontSize: 12, 
        color: theme.palette.mode === 'dark' ? '#fff' : '#666',
        fontWeight: 500
      }}>
        Swipe
      </span>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <ChevronLeft style={{ fontSize: 16, opacity: 0.7 }} />
        <ChevronRight style={{ fontSize: 16, opacity: 0.7 }} />
      </div>
    </div>
  )
}

export default ScrollIndicator